module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAASdJREFUOBGtlTFuwkAQRbNI7mjS5gJcIHW4AhQcIZfhJnQpQkdFzQWIUucClCmc98xYMrLXmGhX+trdmT9fM+vZdXoaGHVdV5hXgVfml6D9MJ/Ah0gp/YY9PyG2Bt/gAN7BAswDrrXpk7POKuGcgS34AsssMRxygmvMrMfHqOMInnvOjEFuxGxvKBgt08wGxbDvwedNUGyMAcZey2dRAc8jWya+ZgwJasO5BGpUbjbgkCNHAJS6vsPxQ208TNtjN0ae6FNjZYZnsBgLwt+MOxxb6qzgBcxbMms/wNSx78TZq5d+/7SMaXP3XFMTgmrRks3Qu/k2LaFRlhqn4m2jYNnGtghEy1299lQQLfc4RJZln69OppbvRfduPvzAXpuxVYsZoX//Av4A2a3Ljp09cCcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/ic-picker-plus.png
// module id = 1885
// module chunks = 0